import { useEffect } from 'react';

import { FUNC_NOOP } from '@libs/constants';

// Экран не гаснет, пока идет эфир: скрытая страница теряет камеру, а на iOS и микрофон.
// Браузер снимает блокировку сам, когда страница уходит в фон, — при возврате просим снова.
// Нет поддержки или отказ (экономия батареи) — эфир идет без блокировки
export function useScreenWakeLock(active: boolean): void {
  useEffect(() => {
    if (!active || !('wakeLock' in navigator)) return;
    let lock: WakeLockSentinel | null = null;
    let disposed = false;

    const request = () => {
      if (document.hidden) return;
      navigator.wakeLock.request('screen').then((sentinel) => {
        if (disposed) sentinel.release().catch(FUNC_NOOP);
        else lock = sentinel;
      }, FUNC_NOOP);
    };
    const onVisibility = () => {
      if (!document.hidden) request();
    };

    request();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      disposed = true;
      document.removeEventListener('visibilitychange', onVisibility);
      lock?.release().catch(FUNC_NOOP);
    };
  }, [active]);
}
